import './index.css';
import Footer from './Footer';
import SiteHeader from './components/SiteHeader';
import WebRoutes from './Router';

const App = () => {
  return (
    <>
      <a className="skip-link" href="#main">
        Skip to content
      </a>
      <SiteHeader />
      <WebRoutes />
      <Footer />
    </>
  );
};

export default App;
